/**
 * author:wangjiang \
 * date:215-10-30
 */
/*
html:<editor-dir editor-json="list.fgd_editinfo" editor-form="newsForm"></editor-dir>
 */
'use strict';
angular.module('trsEditorModule', ['editFlowModule', 'editorOtherModule'])
    . directive('editorDir', ['$modal', '$location', '$timeout', 'trsHttpService', 'modalDialog', function($modal, $location, $timeout, trsHttpService, modalDialog) {
        return {
            restrict: 'E',
            templateUrl: './editingCenter/directive/app/views/editor_tpl.html',
            scope: {
                editorJson: '=',
                editorForm: '=',
                metaDataId: '@'
            },
            link: function(scope, iElement, iAttrs) {
            // 获得路径
                scope.path = $location.path().split('/').pop();
                $timeout(function() {
                    init();
                }, 500);
                $('body').bind('click', blurHide);
                scope.$on('$destroy', function() {
                    $('body').unbind('click', blurHide);
                });

                function blurHide(event) {
                    var $target = $(event.target);
                    if ($target.parents('.icon_add.edit-ChooseType').length === 0 && !$target.hasClass('icon_add')) {
                        $timeout(function() {
                            if (!scope || !scope.status) {return;}
                            scope.status.showSelect = false;
                        });
                    }
                }
                scope.showSelect = function($event) {
                    scope.status.$addButton = $($event.target);
                    scope.status.showSelect = !scope.status.showSelect;
                };
                scope.editFlow = function() {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/directive/app/views/editor_window_editflow_tpl.html',
                        scope: scope,
                        windowClass: 'editor_window_class',
                        backdrop: false,
                        controller: 'editFlowCtrl',
                    });
                    modalInstance.result.then(function(result) {
                        scope.editorJson = contrast(result, angular.copy(scope.editorJson), 'ID');
                        // scope.selected = scope.editorJson[scope.editorJson.length - 1];
                        scope.selected = scope.editorJson[0];
                        // scope.editIndex = scope.editorJson.length - 1;
                        scope.editIndex = 0;
                    });
                };
                scope.other = function() {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/directive/app/views/editor_window_other_tpl.html',
                        scope: scope,
                        windowClass: 'editor_window_class',
                        backdrop: false,
                        controller: 'editorOtherCtrl',
                    });
                    modalInstance.result.then(function(result) {
                        scope.editorJson = contrast(result, angular.copy(scope.editorJson), 'ID');
                        // scope.selected = scope.editorJson[scope.editorJson.length - 1];
                        scope.selected = scope.editorJson[0];
                        scope.editIndex = 0;
                    });
                };
                // 编辑流结束
                scope.showEditor = function(index) {
                // scope.currEditInfo= item;
                    scope.editIndex = index;
                };
                scope.deleteEditor = function(record) {
                    scope.editorJson.splice(record, 1);
                    // scope.editIndex = scope.editorJson.length - 1;
                    scope.editIndex = 0;
                    scope.selected = scope.editorJson[0];
                };
                scope.select = function(editor) {
                    scope.selected = editor;
                };
                // 初始化开始
                function init() {
                // 初始化显示下标开始
                // scope.editIndex = scope.editorJson.length - 1;
                    scope.editIndex = 0;
                    // 初始化显示下标结束
                    scope.newsForm = scope.editorForm;
                    // 获取编辑流信息开始
                    // 获取编辑流列表开始
                    scope.selected = scope.editorJson[0];
                    scope.status = {
                        showSelect: false
                    };
                }
                // 初始化结束
                // 对比是否重复开始
                function contrast(array1, array2, attribute) {
                    angular.forEach(array1, function(data, index, array) {
                        var flag = true;
                        angular.forEach(array2, function(_data, _index, _array) {
                            if (data[attribute] === _data[attribute]) {
                                flag = false;
                            }
                        });
                        if (flag) {
                            array2.push(data);
                        }
                    });
                    return array2;
                }
            // 对比是否重复结束
            }
        };
    }]);
